import TableComponent from '../../../Common/Charts/TableCharts';
import { number } from '../../../Common/Util/number';
import { useProfileChartsDataContext } from './hooks/useProfileChartsDataContext';

export const ByProfessionAnual = () => {
    const { chartData } = useProfileChartsDataContext();

    const tableColumns = [
        {
            key: 'ano_estatistica',
            header: 'Ano',
            headerStyle: { fontWeight: '500' },
            cellStyle: { fontWeight: '400' }
        },
        {
            key: 'profissao',
            header: 'Profissão',
            headerStyle: { fontWeight: '500' },
            cellStyle: { fontWeight: '400' }
        },
        {
            key: 'total',
            header: 'Total',
            headerStyle: { fontWeight: '500', textAlign: 'right' },
            cellStyle: { textAlign: 'right', fontWeight: '400' },
            formatter: (value) => number.formatToBRNumber(value)
        }
    ];

    const rawData = chartData?.byProfessionAnual || [];

    const flattenedData = rawData.flatMap((itemAno) => {
        return itemAno.profissoes.map((profissao) => ({
            ...profissao,
            ano_estatistica: itemAno.ano_estatistica
        }));
    });

    return (
        <div style={{ width: '100%' }}>
            <TableComponent
                data={flattenedData}
                columns={tableColumns}
                title="Por Profissão (Anual)"
                showTotal={true}
                totalColumn="total"
                formatNumber={number.formatToBRNumber}
                maxHeight="500px"
            />
        </div>
    );
};
